import { c as _c } from "react/compiler-runtime";
import { TextArea } from '@sbt-web/ui';
interface MessageProps {
  message: string;
  errorMessage?: string;
  onChangeMessage: (message: string) => void;
}
const MESSAGE_MAX_LENGTH = 2900;
export const MessageField = t0 => {
  const $ = _c(7);
  const {
    message,
    errorMessage,
    onChangeMessage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      label: "Messaggio"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onChangeMessage) {
    t2 = e => onChangeMessage(e.target.value);
    $[1] = onChangeMessage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== errorMessage || $[4] !== message || $[5] !== t2) {
    t3 = <TextArea name="body" placeholder="Inserisci un messaggio" inputHeaderProps={t1} maxLength={MESSAGE_MAX_LENGTH} value={message} onInputChange={t2} errorMessage={errorMessage} />;
    $[3] = errorMessage;
    $[4] = message;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};